import * as React from "react";
import MenuItem from "../components/MenuItem";

import { useCampaign } from "../utils/CampaignStore";
import { ApplicationAction, GetMyQuestionnaires, GetUserQuestionnaireResponse, Questionnaire, QuestionnaireActions, StartQuestionnaire } from "../utils/ServiceManagerAPI";

import { parseJSON } from "date-fns";
import { formatRelative } from "date-fns/formatRelative";
import { Box, Text } from "grommet";
import { useNavigate } from "react-router-dom";
import Countdown from "../components/Countdown";
import SkeletonWrapper from "../components/SkeltonWrapper";
import StyledModal from "../components/StyledModel";
import { useUser } from "../utils/AccountStore";

const RenderScore = ({ questionnaire }: { questionnaire: Questionnaire }) => {
    return questionnaire.score != 0 ? (
        <>
            <br />
            <Text>Score {((questionnaire.score / questionnaire.maxScore) * 100).toFixed(0) + "%"}</Text>
        </>
    ) : (
        <></>
    );
};

let KnowledgeCheck = ({ onChange }) => {
    let [loading, setLoading] = React.useState(true);
    let [starting, setStarting] = React.useState(false);
    let [actions, setActions] = React.useState([] as ApplicationAction[]);
    let { user } = useUser();
    let campaigns = useCampaign();
    let navigate = useNavigate();
    const [questionnaires, setQuestionnaires] = React.useState([] as Questionnaire[]);

    React.useEffect(() => {
        let ids = [campaigns.registrationCampaign.id, campaigns.learningCampaign.id, campaigns.learningStep2Campaign.id, campaigns.submissionCampaign.id];

        if (campaigns.registrationCampaign.id && campaigns.learningCampaign.id && campaigns.learningStep2Campaign.id && campaigns.submissionCampaign.id) {
            GetMyQuestionnaires().then((result: GetUserQuestionnaireResponse) => {
                let q = result.questionnaires.filter((q) => ids.includes(q.campaignID));
                setQuestionnaires(q);

                if (q.length == 1 && q[0].locked == true) {
                    onChange(true);
                }
            });
            QuestionnaireActions().then((result) => {
                result.sort((a, b) => (ids.indexOf(a.data.id) > ids.indexOf(b.data.id) ? 1 : -1));

                setActions(result.filter((a) => (a.type == 1 && ids.includes(a.data.campaignID)) || (a.type == 2 && ids.includes(a.data.id))));
                setLoading(false);
            });
        }
    }, [campaigns.registrationCampaign.id, campaigns.learningCampaign.id, campaigns.learningStep2Campaign.id, campaigns.submissionCampaign.id]);

    let startScreening = (campaignID) => {
        setStarting(true);

        let campaign = [campaigns.registrationCampaign, campaigns.learningCampaign, campaigns.learningStep2Campaign, campaigns.submissionCampaign].filter((c) => c.id == campaignID)[0];

        StartQuestionnaire(campaign).then((id) => {
            navigate(`/knowledgeCheck/${id}`);
        });
    };

    let prettyDate = (d) => {
        const date = new Date(d);

        return formatRelative(date, new Date());
    };

    // const getImage = (campaignID) => {
    //     switch (campaignID) {
    //         case campaigns.registrationCampaign.id:
    //             return isDarkMode ? "/images/registration-dark.png" : "/images/registration-light.png";
    //         case campaigns.learningCampaign.id:
    //             return isDarkMode ? "/images/learning-dark.png" : "/images/learning-light.png";
    //         case campaigns.submissionCampaign.id:
    //             return isDarkMode ? "/images/submission-dark.png" : "/images/submission-light.png";
    //     }
    // };

    const getImage = (campaignID) => {
        switch (campaignID) {
            case campaigns.registrationCampaign.id:
                return "/images/registration.jpeg";
            case campaigns.learningCampaign.id:
                return "/images/learning.jpeg";
            case campaigns.learningStep2Campaign.id:
                return "/images/learning-2.jpeg";
            case campaigns.submissionCampaign.id:
                return "/images/submission.jpeg";
        }
    };

    const getCampaign = (id) => {
        switch (id) {
            case campaigns.registrationCampaign.id:
                return campaigns.registrationCampaign;
            case campaigns.learningCampaign.id:
                return campaigns.learningCampaign;
            case campaigns.learningStep2Campaign.id:
                return campaigns.learningStep2Campaign;
            case campaigns.submissionCampaign.id:
                return campaigns.submissionCampaign;
        }
    };

    const isActive = (campaignID) => {
        let campaignStartDate = getCampaign(campaignID)?.startDate;

        if (campaignStartDate) {
            return parseJSON(campaignStartDate) <= new Date();
        }

        return true;
    };

    const RenderAction = ({ campaignID }) => {
        return (
            <>
                {questionnaires
                    .filter((q) => q.campaignID == campaignID)
                    .map((questionnaire) => (
                        <Box key={questionnaire.id}>
                            <MenuItem
                                name={questionnaire.campaign.name}
                                description={""}
                                image={getImage(questionnaire.campaignID)}
                                subtext={
                                    questionnaire.locked ? (
                                        <Text>
                                            Complete <RenderScore questionnaire={questionnaire}></RenderScore>
                                        </Text>
                                    ) : (
                                        "Started " + prettyDate(questionnaire.timestamp)
                                    )
                                }
                                action={() => {
                                    navigate(`/knowledgeCheck/${questionnaire.id}`);
                                }}
                            ></MenuItem>
                        </Box>
                    ))}
                {actions
                    .filter((q) => q.data.id == campaignID)
                    .map((action, i) => (
                        <div key={i}>
                            {action.type == 2 && (
                                <MenuItem
                                    name={isActive(action.data.id) ? "Start" : action.text}
                                    description={
                                        isActive(action.data.id) ? (
                                            <Text>{action.text}</Text>
                                        ) : (
                                            <Text size="small">
                                                Opens <Countdown size="small" targetDate={parseJSON(getCampaign(action.data.id)?.startDate || "")}></Countdown>
                                            </Text>
                                        )
                                    }
                                    image={getImage(action.data.id)}
                                    active={isActive(action.data.id)}
                                    action={() => startScreening(action.data.id)}
                                ></MenuItem>
                            )}
                            {/* {action.type == 1 && (
                                        <MenuItem
                                            name={action.text}
                                            description={""}
                                            image={getImage(action.data.campaignID)}
                                            subtext={prettyDate(action.data.timestamp)}
                                            action={() => {
                                                navigate(`/knowledgeCheck/${action.data.id}`);
                                            }}
                                        ></MenuItem>
                                    )} */}
                        </div>
                    ))}
            </>
        );
    };
    return (
        <div>
            <SkeletonWrapper loading={loading}>
                <Box style={{ minHeight: "100px" }} margin={{ bottom: "medium" }}>
                    {/* {registrationsCloseDate > new Date() && (
                        <Box align="center">
                            <Text size={"large"}>Registrations Close:</Text>
                            <Countdown size={"large"} color="brandColor" targetDate={registrationsCloseDate}></Countdown>
                        </Box>
                    )}
                    {registrationsCloseDate < new Date() && gameSubmissionOpenDate > new Date() && (
                        <Box align="center">
                            <Text size={"large"}>Game Submissions Open:</Text>
                            <Countdown size={"large"} color="brandColor" targetDate={gameSubmissionOpenDate}></Countdown>
                        </Box>
                    )}
                    {registrationsCloseDate < new Date() && gameSubmissionOpenDate < new Date() && gameSubmissionCloseDate > new Date() && (
                        <Box align="center">
                            <Text size={"large"}>Game Submissions Close:</Text>
                            <Countdown size={"large"} color="brandColor" targetDate={gameSubmissionCloseDate}></Countdown>
                        </Box>
                    )} */}
                    {campaigns && (
                        <Box direction="row" gap="small" justify="center" wrap>
                            <RenderAction campaignID={campaigns.registrationCampaign.id}></RenderAction>
                            <RenderAction campaignID={campaigns.learningCampaign.id}></RenderAction>
                            <RenderAction campaignID={campaigns.learningStep2Campaign.id}></RenderAction>
                            <RenderAction campaignID={campaigns.submissionCampaign.id}></RenderAction>
                        </Box>
                    )}
                    <StyledModal isOpen={starting} setIsOpen={setStarting}>
                        <Text>Loading</Text>
                    </StyledModal>
                </Box>
            </SkeletonWrapper>
        </div>
    );
};

export default KnowledgeCheck;
